// extracted by mini-css-extract-plugin
module.exports = {"mute":"Video_mute__04cim"};